import { ConfiguratorGroupDto } from '@/services/configurator/configurator.types';

function collectDependentGroupIds(
    allGroups: ConfiguratorGroupDto[],
    parent: ConfiguratorGroupDto,
    visited: Set<number>
): void {
    const relatedGroupIds = new Set(parent.options.flatMap((o) => o.dependencyConflicts.map((fw) => fw.groupId)));
    for (const id of relatedGroupIds) {
        if (!visited.has(id)) {
            visited.add(id);
            const group = allGroups.find((g) => g.id === id);
            if (group) collectDependentGroupIds(allGroups, group, visited);
        }
    }
}

export function findDependentGroups(
    allGroups: ConfiguratorGroupDto[],
    parent: ConfiguratorGroupDto
): ConfiguratorGroupDto[] {
    const visited = new Set<number>([parent.id]);
    collectDependentGroupIds(allGroups, parent, visited);
    return [...visited]
        .filter((id) => id !== parent.id)
        .map((id) => allGroups.find((g) => g.id === id))
        .filter((g): g is ConfiguratorGroupDto => g !== undefined);
}
